import { useCallback, useEffect, useState } from "react";
import {
  ProductDetailDTO,
  ProductSubType,
  ProgramScheduleDTO,
  ServicingTrainerType,
  TrainerProgramApproval,
} from "@campgladiator/cg-common.types.types";
import { SelectedTrainer } from "../components/UpgradeMembershipModal/components/SelectTrainer/SelectTrainer";
import { SelectedProductOption } from "../components/UpgradeMembershipModal/components/SelectProduct";
import { getProgramApprovedTypeBySelectedProductDetail } from "../components/SelectTrainerInput/logic";

export type ChangeTrainerSubscriptionArgs = {
  currentServicingTrainer?: string;
  currentTrainerName?: ServicingTrainerType["name"];
  currentTrainerPhotoUrl?: ServicingTrainerType["photoUrl"];
  currentTrainerSchedule?: ProgramScheduleDTO[];
  selectedProductOption: SelectedProductOption;
};

const useUpdateTrainer = ({
  currentServicingTrainer,
  currentTrainerName,
  currentTrainerPhotoUrl,
  currentTrainerSchedule,
  selectedProductOption,
}: ChangeTrainerSubscriptionArgs) => {
  const [approvedProgram, setApprovedProgram] =
    useState<TrainerProgramApproval[]>();
  const [selectedTrainer, setSelectedTrainer] = useState<SelectedTrainer>(
    {} as SelectedTrainer
  );

  const onUpdateSubscriptionDetails = useCallback(
    ({ selectedProductOption }: ChangeTrainerSubscriptionArgs) => {
      const { approvedType, onlineApprovedIfOutdoor, outdoorApprovedIfOnline } =
        getProgramApprovedTypeBySelectedProductDetail(
          selectedProductOption?.productDetails as ProductDetailDTO
        );

      setApprovedProgram([
        approvedType,
        outdoorApprovedIfOnline,
        onlineApprovedIfOutdoor,
      ]);
    },
    [selectedProductOption]
  );

  const handleOnClearTrainerSearch = () => {
    setSelectedTrainer("" as any);
  };

  useEffect(() => {
    const trainer: SelectedTrainer = {
      itemId: currentServicingTrainer,
      text: currentTrainerName,
      avatar: { src: currentTrainerPhotoUrl },
      type: "item",
      programSchedules: currentTrainerSchedule,
    };
    setSelectedTrainer(trainer);
  }, [currentServicingTrainer, currentTrainerPhotoUrl]);

  useEffect(() => {
    onUpdateSubscriptionDetails({
      selectedProductOption,
    });
  }, [onUpdateSubscriptionDetails]);

  return {
    approvedProgram,
    selectedTrainer,
    onClearTrainerSearch: handleOnClearTrainerSearch,
    onItemSelect: setSelectedTrainer,
  };
};

export default useUpdateTrainer;
